import { mergeStyles } from "office-ui-fabric-react";
import React from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import OrderDetailTxt from "../edditOrder/OrderDetailTxt";
import { translateOrderTypeName } from "../../../../common/enums/orderTypes.enum";

const ReadOnlyDetails: React.FC = () => {
  const { t } = useTranslation("admin");
  const { orderDetails } = useSelector(
    (state: RootStateOrAny) => state.orderPanel
  );

  const wrapper = mergeStyles({
    display: "flex",
    justifyContent: "space-between",
  });
  
  const mainWrapper = mergeStyles({
    paddingTop: 20,
    paddingBottom: 15
  })
  const divider = mergeStyles({
    width: 250,
  });

  return (
    <div className={mainWrapper}>
      <div className={wrapper}>
        <div className={divider}>
        <OrderDetailTxt
          title={t("nav.orderNumber")}
          value={orderDetails ? orderDetails.orderInfo.number : ""}
        />
        </div>
        <div className={divider}>
          <OrderDetailTxt
            title={t("nav.clientName")}
            value={orderDetails ? orderDetails.orderInfo.company : ""}
          />
        </div>
      </div>
      <div className={wrapper}>
      <div className={divider}>
          <OrderDetailTxt
            title={t("nav.orderTypeTitle")}
            value={orderDetails ? translateOrderTypeName(orderDetails.orderInfo.type, t) : ""}
          />
        </div>
         <div className={divider}>
          <OrderDetailTxt
            title={t("nav.receptionAddress")}
            value={orderDetails ? orderDetails.orderInfo.receptionPlace : ""}
          />
         </div>
      </div>
    </div>
  );
};

export default ReadOnlyDetails;